/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Model } from '@app/shared/models/model.model';
import { UserRole } from '@app/settings/users/roles/user-role.model';

@Injectable({
  providedIn: 'root',
})
export class RolesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery): Observable<PaginatedResponse> {
    return this.http.get('v1/roles', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((role: any) => {
          return new UserRole().deserialize(role);
        });
        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(userRole: any): Observable<UserRole> {
    return this.http.put('v1/roles/' + userRole.id, userRole).pipe(
      map((response: HttpResponse) => {
        return new UserRole().deserialize(response.data);
      })
    );
  }

  store(role: any): Observable<UserRole> {
    return this.http.post('v1/roles', role).pipe(
      map((response: HttpResponse) => {
        return new UserRole().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/roles/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new UserRole().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/roles/' + id);
  }
}
